import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogService,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
} from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UsuarioResposta } from '../../core/api/usuario';
import { UsuarioAppService } from '../../core/api/usuario-app.service';
import { UsuarioFormComponent } from './usuario-form/usuario-form.component';
import { ListaVaziaComponent } from '../../shared/lista-vazia/lista-vazia.component';

import { BarraCarregandoComponent } from '../../shared/barra-carregando/barra-carregando.component';
import { finalize } from 'rxjs/operators';
import { Ordenacao, OrdenavelComponent, paraParametroSort } from '../../shared/ordenavel/ordenavel.component';
@Component({
  selector: 'app-usuarios',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbButtonModule,
    NbFormFieldModule,
    NbInputModule,
    NbIconModule,
    ListaVaziaComponent,
    BarraCarregandoComponent,
    OrdenavelComponent,
  ],
  templateUrl: './usuarios.component.html',
  styleUrl: './usuarios.component.scss',
})
export class UsuariosComponent implements OnInit, OnDestroy {
  /**
   * `TAB-01` — ordenação **no servidor**, porque a listagem é paginada pela API.
   * O estado inicial espelha o padrão do contrato: nome ascendente.
   */
  ordenacao: Ordenacao | null = { campo: 'nome', direcao: 'asc' };

  ordenarPor(o: Ordenacao): void {
    this.ordenacao = o;
    this.page = 1;
    this.carregar();
  }

  protected get sort(): string | null {
    return paraParametroSort(this.ordenacao);
  }

  usuarios: UsuarioResposta[] = [];
  page = 1;
  size = 10;
  totalPages = 0;
  carregando = false;
  filtro = '';

  /** `TAB-12` — separa "não há usuário" de "o recorte atual não casou com nenhum". */
  get temFiltro(): boolean {
    return !!this.filtro.trim();
  }

  limparFiltro(): void {
    this.filtro = '';
    this.buscarAgora();
  }

  private readonly filtroBusca = new Subject<string>();
  private filtroSub?: Subscription;

  constructor(
    private usuarioService: UsuarioAppService,
    private dialog: NbDialogService,
  ) {}

  ngOnInit(): void {
    this.carregar();
  }

  ngOnDestroy(): void {
    this.filtroSub?.unsubscribe();
  }

  /** `FIL-01` — o filtro vale quando a pessoa manda: Enter ou botão, nunca ao digitar. */
  buscarAgora(): void {
    this.page = 1;
    this.carregar();
  }

  pesquisar(): void {
    this.buscarAgora();
  }

  carregar(): void {
    this.carregando = true;
    this.usuarioService
      .listar(this.page - 1, this.size, this.filtro, this.sort)
      .pipe(finalize(() => (this.carregando = false)))
      .subscribe({
      next: (res) => {
        this.usuarios = res.content ?? [];
        this.totalPages = res.totalPages ?? 1;
      },
    });
  }

  onPageChange(p: number): void {
    this.page = p;
    this.carregar();
  }

  novo(): void {
    this.dialog.open(UsuarioFormComponent).onClose.subscribe((ok) => ok && this.carregar());
  }

  editar(u: UsuarioResposta): void {
    this.dialog.open(UsuarioFormComponent, { context: { usuario: u } }).onClose.subscribe((ok) => ok && this.carregar());
  }

  perfilLabels(u: UsuarioResposta): string {
    const p: string[] = [];
    if (u.admin) p.push('Admin');
    if (u.coordenacao) p.push('Coordenação');
    if (u.catequista) p.push('Catequista');
    return p.length ? p.join(' · ') : '—';
  }
}
